import CustomModal from "components/CustomModal";
import get from "lodash/get";
import omit from "lodash/omit";
import { removeEmptyValueFromObject } from "utils";
import { getLocaleString } from "utils/localization/locale";
import Button from "./Button";
import Toaster from "./Toaster";

export default function SaveSearchModal(props) {
  const {
    saveSearch,
    showSearchModal,
    saveSearchReqObj,
    setShowSearchModal,
    setSaveSearchReqObj,
  } = props;

  return (
    <CustomModal
      size="sm"
      onHide={() => setShowSearchModal(false)}
      show={showSearchModal}
      title={getLocaleString(
        "saved_search.save_this_search",
        "Save this search"
      )}
      className="mt-4"
      footer={() => (
        <Button
          type="button"
          data-cy="submit_search"
          disabled={!get(saveSearchReqObj, "name", "")}
          onClick={() =>
            saveSearch(
              removeEmptyValueFromObject(
                omit(
                  {
                    ...saveSearchReqObj,
                    name: get(saveSearchReqObj, "name", "").trim(),
                    filters: removeEmptyValueFromObject(
                      get(saveSearchReqObj, "filters", {})
                    ),
                  },
                  !get(saveSearchReqObj, "id", "")
                    ? []
                    : [
                        "search_id",
                        "created_at",
                        "client_id",
                        "user_id",
                        "search_type",
                      ]
                )
              )
            )
              .then((response) => {
                if (response) {
                  Toaster(
                    getLocaleString(
                      "saved_search.search_saved",
                      "Search saved"
                    ),
                    "success"
                  );
                  setShowSearchModal(false);
                  setSaveSearchReqObj({
                    ...saveSearchReqObj,
                    name: "",
                    access_type: "",
                    id: "",
                  });
                }
              })
              .catch(() => {
                Toaster(
                  getLocaleString(
                    "saved_search.search_saved_failed",
                    "Failed to save search"
                  ),
                  "error"
                );
                setShowSearchModal(false);
              })
          }
        >
          {getLocaleString("common.submit", "Submit")}
        </Button>
      )}
      modalBodyStyle={{ maxHeight: "calc(100vh - 210px)", overflow: "auto" }}
    >
      <div>
        <label className="d-block w-100">
          <strong>
            {getLocaleString("saved_search.search_name", "Search Name")}:
          </strong>
          <input
            maxLength={100}
            type="text"
            value={get(saveSearchReqObj, "name", "")}
            className="form-control w-100"
            onChange={(e) =>
              setSaveSearchReqObj(
                omit(
                  {
                    ...saveSearchReqObj,
                    name: get(e, "target.value", ""),
                  },
                  ["saved_search_details"]
                )
              )
            }
          />
        </label>
        <label className="mt-2 d-block w-100">
          <strong>
            {getLocaleString("saved_search.access_type", "Access Type")}:
          </strong>
          <select
            onChange={(e) =>
              setSaveSearchReqObj({
                ...saveSearchReqObj,
                access_type: e.target.value,
              })
            }
            value={get(saveSearchReqObj, "access_type", "")}
            className="form-control w-100"
          >
            <option value="Public">
              {getLocaleString("saved_search.public", "Public")}
            </option>
            <option value="Private">
              {getLocaleString("saved_search.private", "Private")}
            </option>
          </select>
        </label>
      </div>
    </CustomModal>
  );
}
